import { ZodEffects, ZodType } from "zod";

export enum ZodFieldType {
  OBJECT = "ZodObject",
  STRING = "ZodString",
  NUMBER = "ZodNumber",
  BOOLEAN = "ZodBoolean",
}

export function getZodField(obj: ZodType) {
  const zodFieldName = getZodFieldTypeName(obj) as ZodFieldType;
  if (!Object.values(ZodFieldType).includes(zodFieldName)) {
    throw new Error(
      `getZodField Error: Only ${Object.values(ZodFieldType).join(`, `)} ZodTypes are supported, received ${zodFieldName}.`,
    );
  }
  // type will be ZodEffects if the schema / field has refine or superRefine effects
  if (obj instanceof ZodEffects && obj._def.schema instanceof ZodType) {
    return obj._def.schema;
  }
  return obj;
}

/**
 * Recursively check for obj.innerType, etc to find the deepest `typeName`
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- This is a generic zod type, we can't use `unknown` here
export function getZodFieldTypeName(obj: ZodType<any, any, any>): string {
  if (
    "schema" in obj._def &&
    obj instanceof ZodEffects &&
    obj._def.schema instanceof ZodType
  ) {
    return getZodFieldTypeName(obj._def.schema);
  }

  if ("innerType" in obj._def) {
    return getZodFieldTypeName((obj._def as { innerType: ZodType }).innerType);
  }

  if (
    "typeName" in obj._def &&
    typeof (obj._def as { typeName: unknown }).typeName === "string"
  ) {
    return (obj._def as { typeName: string }).typeName;
  }
  throw new Error("getZodFieldTypeName: Unable to determine field type");
}
